import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, refinementList } from 'instantsearch.js/es/widgets';
import ScrollSpy from '@three11/scrollspy';
import { tns } from 'tiny-slider';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

   let $navbar = $('#navbarCollapse');
   let $focusableElements = $navbar.find('a, button, input, [tabindex]:not([tabindex="-1"])');
   let $lastFocusableEl = $focusableElements.last();

   $lastFocusableEl.on('blur', function() {
    if ($navbar.hasClass('show')) {  // Check if the navbar is expanded
      $navbar.collapse('hide');
    }
  });

   function trapFocusFor(element) {
    let $focusableElements = element.find('a, button, input, [tabindex]:not([tabindex="-1"])');
    let $firstFocusableEl = $focusableElements.first();
    let $lastFocusableEl = $focusableElements.last();

    element.on('keydown', function(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        if (e.shiftKey) /* shift + tab */ {
          if (document.activeElement === $firstFocusableEl[0]) {
            $lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (document.activeElement === $lastFocusableEl[0]) {
            $firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  $('.focus-trap').each(function() {
    trapFocusFor($(this));
  });


  if ($('ion-icon').length) {

    $('ion-icon').each(function() {
      $(this).attr('aria-hidden','true');
      $(this).attr('role','presentation');

    });

  }

  if ($('i').length) {
    $('i').each(function() {
      $(this).attr('role','presentation');
    });
  }


  $('.dynamic_select').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
            }
            return false;
          });

  if ($('.wujw-carousel').length) {
    var i = 0;
    $('.wujw-carousel').each(function () {
      $(this).attr('id','wujw-carousel-'+i);
      var count = parseInt($(this).attr('count'));
      var slider_count = 4;
      if(count){
        slider_count = count;
      }

      var slider = tns({
        container: '#wujw-carousel-'+i,
        responsive: {
          '480': {
            'items': 1,
          },
          '992': {
            'items': slider_count,
          },
        },
        slideBy: 'page',
        autoplay: false,
        mouseDrag: true,
        gutter: 15,
        loop: false,
        navPosition: 'bottom',
        controlsText: ['<ion-icon name="chevron-back-outline"></ion-icon>', '<ion-icon name="chevron-forward-outline"></ion-icon>'],
      });

      i=i+1;

    });

  }

  // JavaScript to be fired on all pages
  function toggleAffix(affixElement, height, offset) {
    if (jQuery(document).scrollTop() > offset && $( window ).width() > 991) {
      $('#navFill').height(height);
      affixElement.addClass('affix');
    }
    else {
      $('#navFill').height(0);
      affixElement.removeClass('affix');
    }
  }


  $( '.faq-search' ).on('input', function() {
    var search = $(this).val().toLowerCase();
    if(search.length > 0){
      $('.toggle-extra').hide();
      $( $(this).attr('search')+' > .collapse').addClass('show');

      $( $(this).attr('search')+' .accordion-button').each(function () {
        console.log($(this).text());
        if($(this).text().toLowerCase().includes(search)){
          $(this).show();
        }
        else{
         $(this).hide();
       }

     });
    }
    else{
      $('.toggle-extra').show();
      $( $(this).attr('search')+' .accordion-button').show();
    }
  });



  jQuery('[data-toggle="affix"]').each(function () {
    var ele = jQuery(this);
    var height = ele.innerHeight();
    var offset = ele.offset().top;
    jQuery(window).on('scroll resize', function () {
      toggleAffix(ele,height,offset);
    });
  });


  if ($('#secondary-menu').length) {

    new ScrollSpy({
      linkCurrentClass: 'current',
      linksContainerSelector: '.secondary-menu',
      sectionSelector: '.scrollspy',
      headerOffset: false,
      headerClass: '.secondary-menu-header',
      animationSpeed: 300,
      animationEasing: 'easeInCubic',
      onAfterScroll: () => {
        console.log('scroll ended');
      },
    });

  }

  $('#nav-icon').click(function () {
    $(this).toggleClass('open');
  });

  $('.open-link').click(function () {
    window.location = $(this).attr('href');
  });


  $('div[data-wujw-toggle="collapse"]').click(function(e) {
    e.preventDefault();
    $('.'+$(this).attr('data-wujw-toggle-close')).hide();
    $(this).closest('.toggles').find('.elementor-widget-button').removeClass('toggle-active');
    $(this).addClass('toggle-active');
    $($(this).attr('data-wujw-target')).show();
  });

  $('div[data-wujw-collapse="collapse"]').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('toggle-active');
    $($(this).attr('data-wujw-target')).toggleClass('show');
  });



  function searching(query,source) {
    if (query.length > 0) {
      showSearch(true,source);
    }
    else{
      showSearch(false,source);
    }
  }

  function showSearch(show,source){
    if ($('#hits').length) {
      if(show){
        if(source=='gemeente'){
         $('#hits-gemeente').addClass('show');
       }
       else{
         $('#hits').addClass('show');
       }
     }
     else{
      if(source=='gemeente'){
        $('#hits-gemeente').removeClass('show');
      }
      else{
        $('#hits').removeClass('show');
      }
    }
  }
}

var initSearch = false;
var initGemeente = false;
var searchClient = false;

$('.search-box').click(function(e){

  if(initSearch == false){
    startSearch();
    initSearch = true;
    $('.search-box input')[0].focus(); 
  }

});

function startSearch(){

  searchClient = algoliasearch('8GD69UYLC3', '67204e2c324ca3f758876fa5933d29b4');
  const search = instantsearch({
    indexName: 'website',
    searchClient,
  });

  search.addWidgets([
    searchBox({
      container: '#search',
      placeholder: 'Zoeken',
      hitsPerPage: 10,
      templates: {
        submit: '<ion-icon name="search"></ion-icon>',
        reset: '<ion-icon name="close d-none"></ion-icon>',
        resetTitle: 'Klik om het zoekveld leeg te maken.',
        submitTitle: 'Klik om de zoekopdracht uit te voeren.',
      },
      cssClasses: {
        input: ['form-control search-padding'],
      },
      queryHook(query, search) {
        searching(query,'general');
        search(query,'general');
      },
    }),

    hits({
      container: '#hits',
      templates: {
        item: `
        <a href="{{ link }}" class="no-decoration">
        <div class="library-result position-relative bg-white rounded enlarge">
        <div class="row d-flex align-items-center">
        <div class="col-12">
        <div class="p-1 pe-2">
        <div class="search-meta">
        <strong>{{ title }}</strong>
        <small class="d-block">{{ type.name }}<small>
        </div>
        </div>
        </div>
        </div>
        </div>
        </a>`,
        empty: '<span aria-live="polite">Geen resultaten gevonden voor <q>{{ query }}</q></span>',
      },
    }),
    ]);

  search.start();

  search.on('render', () => {
    $('.ais-SearchBox-input').attr('aria-label', 'Voer uw zoekterm in');
  });
}

function startGemeente(){
  const gemeenteSearch = instantsearch({
    indexName: 'website',
    searchClient,
    initialUiState: {
      website: {
        refinementList: { 'type.name': ['gemeente'] },
      },
    },
  });

  gemeenteSearch.addWidgets([
    searchBox({
      container: '#search-gemeente',
      placeholder: 'Bijvoorbeeld Zaanstad',
      templates: {
        submit: '<ion-icon name="search"></ion-icon>',
        reset: '<ion-icon name="close d-none"></ion-icon>',
        resetTitle: 'Klik om het zoekveld leeg te maken.',
        submitTitle: 'Klik om de zoekopdracht uit te voeren.',

      },
      cssClasses: {
        input: ['form-control search-padding'],
      },
      queryHook(query, search) {
        searching(query,'gemeente');
        search(query,'gemeente');
      },
    }),

    refinementList({
      container: '#full-type-filter',
      attribute: 'type.name',
    }),

    hits({
      container: '#hits-gemeente',
      templates: {
        item: `
        <a href="{{ link }}" class="no-style ">
        <div class="library-result position-relative">
        <div class="row d-flex align-items-center">
        <div class="col-3">
        <img class="img-fluid rounded" src="{{image}}" alt="">
        </div>
        <div class="col">
        <div class="">
        <div class="search-meta h4 mb-0">
        {{ title }}
        </div>
        </div>
        </div>
        </div>
        </div>
        </a>`,
        empty: 'In deze gemeente hebben wij momenteel geen actie lopen',
      },
    }),
    ]);

  gemeenteSearch.start();
}


$('#search-gemeente').click(function(e){

 if(initSearch == false){
  startSearch();
  initSearch = true;

}

if(initGemeente == false){
  initGemeente = true;
  startGemeente();
  $('#search-gemeente input')[0].focus(); 

}

});


},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js